module.exports = {"pt-BR":{"notifications":{"index":{"title":"Notificações","empty":"Sem resultados","unread":"Apenas notificações não lidas"}}}}